import { FileUploadStatus } from "../ducks/file";

export const getFileSizeInMB = (file: File): number => {
  return file.size / 1024 / 1024;
};

export const getFileStatus = (status: number) => {
  switch (status) {
    case 0:
      return FileUploadStatus.Waiting;
    case 1:
      return FileUploadStatus.Processing;
    case 2:
      return FileUploadStatus.Success;
    case 7:
      return FileUploadStatus.SystemError;
    case 8:
      return FileUploadStatus.DataError;
    case 9:
      return FileUploadStatus.UploadError;
    default:
      return FileUploadStatus.Waiting;
  }
};

export const getFileStatusText = (status: FileUploadStatus): string => {
  switch (status) {
    case FileUploadStatus.Waiting:
      return "処理中";
    case FileUploadStatus.Processing:
      return "処理中";
    case FileUploadStatus.Success:
      return "正常登録";
    case FileUploadStatus.SystemError:
      return "データエラー";
    case FileUploadStatus.DataError:
      return "データエラー";
    case FileUploadStatus.UploadError:
      return "データエラー";
    default:
      return "";
  }
};
